import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'nallian-shared-ui/lib/components';
// import compareAsc from 'date-fns/compareAsc';
import {
  FieldComponent,
  SelectFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { FormModal } from 'nallian-shared-ui/lib/modules';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import FetchHandlerModule from 'nallian-shared-ui/lib/modules/FetchHandlerModule';
import accessRightStatesService from '../services/accessRightStatesService';
import VehicleFormFields, {
  validateVehicleFormFields,
} from '../../vehicles/components/VehicleFormFields';
import VehicleSelector from './VehicleSelector';
import ExistingVehicleMessage from '../../vehicles/components/ExistingVehicleMessage';
import vehicleByLicensePlateService from '../../vehicles/services/vehicleByLicensePlateService';
import addVehicleToPrivateListService from '../../vehicles/services/addVehicleToPrivateListService';
import createVehicleService from '../../vehicles/services/createVehicleService';

const STEPS = {
  VEHICLE_SELECTION: 0,
  VEHICLE_CREATION: 1,
  ADD_TO_PRIVATE_LIST: 2,
  ACCESS_RIGHT_CREATION: 3,
};

const STEP_SAVE_BUTTON_MAP = {
  [STEPS.VEHICLE_SELECTION]: { content: 'next', icon: 'arrow right', iconPosition: 'right' },
  [STEPS.VEHICLE_CREATION]: { content: 'next', icon: 'arrow right', iconPosition: 'right' },
  [STEPS.ADD_TO_PRIVATE_LIST]: { content: 'add', icon: 'add', iconPosition: 'left' },
  [STEPS.ACCESS_RIGHT_CREATION]: { content: 'save', icon: 'save', iconPosition: 'left' },
};

class AccessRightFormModal extends PureComponent {
  componentDidMount() {
    this.props.dispatchAccessRightStatesGet();
  }
  componentDidUpdate = prevState => {
    const { vehicleByLicensePlateFetch } = this.props;
    if (!prevState.vehicleByLicensePlateFetch.fulfilled && vehicleByLicensePlateFetch.fulfilled) {
      this.setState({ step: STEPS.ADD_TO_PRIVATE_LIST });
    }

    if (!prevState.vehicleByLicensePlateFetch.rejected && vehicleByLicensePlateFetch.rejected) {
      this.setState({ step: STEPS.VEHICLE_CREATION });
    }
  };

  // If vehicleId is prefilled or form is for editing only access_right_creation step is shown
  state = {
    step:
      this.props.vehicleId || this.props.editMode
        ? STEPS.ACCESS_RIGHT_CREATION
        : STEPS.VEHICLE_SELECTION,
  };

  isCurrentStep = expectedStep => this.state.step === expectedStep;

  getHeader = () => {
    const { licensePlate, step } = this.state;
    const { t } = this.props;
    if (licensePlate) {
      if (step === STEPS.ADD_TO_PRIVATE_LIST) {
        return t('addVehicleToPrivateListWithLicensePlate', { licensePlate });
      }
      if (step === STEPS.VEHICLE_CREATION) {
        return t('newVehicleWithLicensePlate', { licensePlate });
      }
      if (step === STEPS.ACCESS_RIGHT_CREATION) {
        return t('addAccessRightForVehicleWithLicensePlate', { licensePlate });
      }
    }
    return this.props.header;
  };

  submitForm = ({ selectedVehicle, owner, ...values }) => {
    this.props.onSubmit({
      vehicleId: this.props.vehicleId,
      ...values,
      ...selectedVehicle,
      ...owner,
    });
  };

  validate = values => {
    const { t } = this.props;
    const errors = validateVehicleFormFields(values, t);
    if (
      !values.selectedVehicle ||
      (!values.selectedVehicle.vehicleId && !values.selectedVehicle.licensePlate)
    ) {
      errors.selectedVehicle = t('selectVehicleErr');
    }

    if (values.stateId === undefined) {
      errors.stateId = t('selectStateErr');
    }
    // if (!values.validFrom) {
    //   errors.validFrom = t('chooseDateErr');
    // }
    // if (!values.validUntil) {
    //   errors.validUntil = t('chooseDateErr');
    // }

    // if (values.validFrom && values.validUntil && !compareAsc(values.validFrom, values.validUntil)) {
    //   errors.validUntil = t('dateOrderErr');
    // }

    if (!values.licensePlate || !values.licensePlate.trim()) {
      errors.licensePlate = t('noLicensePlateErr');
    }

    return errors;
  };

  handleSubmit = object => {
    const { data, vehicleByLicensePlateFetch } = this.props;
    const { step, vehicleId } = this.state;
    const { selectedVehicle, owner, ...otherParams } = object;

    switch (step) {
      case STEPS.ACCESS_RIGHT_CREATION:
        this.submitForm({
          vehicleId,
          ...data,
          ...otherParams,
        });
        break;
      case STEPS.VEHICLE_SELECTION:
        // If new vehicle first launch check if vehicle exists
        if (selectedVehicle && selectedVehicle.licensePlate) {
          // This call answer will move the form forward (to ADD_TO_PRIVATE_LIST or VEHICLE_CREATION)
          this.props.dispatchVehicleByLicensePlateGet(selectedVehicle.licensePlate);
          this.setState({ licensePlate: selectedVehicle.licensePlate });
        } else {
          // Vehicle with vehicleId selected, go to ACCESS_RIGHT_CREATION
          this.setState({
            step: STEPS.ACCESS_RIGHT_CREATION,
            vehicleId: selectedVehicle.vehicleId,
          });
        }
        break;
      case STEPS.VEHICLE_CREATION:
        this.props.dispatchCreateVehiclePost(
          { ...selectedVehicle, ...owner, ...otherParams },
          {
            callback: createdVehicle =>
              this.setState({
                step: STEPS.ACCESS_RIGHT_CREATION,
                vehicleId: createdVehicle.id,
                licensePlate: createdVehicle.licensePlate,
              }),
            redirectRoute: undefined,
          }
        );
        break;
      case STEPS.ADD_TO_PRIVATE_LIST:
        // Add to private list and move form to ACCESS_RIGHT_CREATION
        this.props.dispatchAddVehicleToPrivateListPost(vehicleByLicensePlateFetch.value, () =>
          this.setState({
            step: STEPS.ACCESS_RIGHT_CREATION,
            vehicleId: vehicleByLicensePlateFetch.value.id,
          })
        );
        break;
      default:
        break;
    }
  };

  render() {
    const {
      submitProcessing,
      dataLoading,
      data,
      getAccessRightStatesForSelectOptions,
      accessRightStatesFetch,
      returnRoute,
      noStateField,
      vehicleByLicensePlateFetch,
      addVehicleToPrivateListFetch,
      createVehicleFetch,
      t,
    } = this.props;
    const { step } = this.state;
    return (
      <FormModal
        header={this.getHeader()}
        dataLoading={dataLoading}
        submitProcessing={
          submitProcessing ||
          !!vehicleByLicensePlateFetch.pending ||
          !!addVehicleToPrivateListFetch.pending ||
          !!createVehicleFetch.pending
        }
        onSubmit={this.handleSubmit}
        saveButtonIcon={STEP_SAVE_BUTTON_MAP[step].icon}
        saveButtonIconPosition={STEP_SAVE_BUTTON_MAP[step].iconPosition}
        saveButtonContent={t(STEP_SAVE_BUTTON_MAP[step].content)}
        data={data}
        validate={this.validate}
        form="AccessRightFormModal"
        cancelRoute={returnRoute}
        noScroll
        cancelButtonContent={t('cancel')}
      >
        <FetchHandlerModule fetches={[getAccessRightStatesForSelectOptions]}>
          {
            {
              [STEPS.VEHICLE_SELECTION]: (
                <Field component={VehicleSelector} name="selectedVehicle" />
              ),
              [STEPS.VEHICLE_CREATION]: (
                <VehicleFormFields
                  submitProcessing={submitProcessing}
                  dataLoading={dataLoading}
                  data={data}
                />
              ),
              [STEPS.ADD_TO_PRIVATE_LIST]: (
                <ExistingVehicleMessage vehicle={vehicleByLicensePlateFetch.value} />
              ),
              [STEPS.ACCESS_RIGHT_CREATION]: (
                <Fragment>
                  {!noStateField && (
                    <Field
                      label={t('state')}
                      name="stateId"
                      placeholder={t('state')}
                      component={FieldComponent}
                      valueComponent={SelectFieldValueComponent}
                      options={getAccessRightStatesForSelectOptions().filter(
                        item => item.value === 1 // only active items in fase 1
                      )}
                      disabled={submitProcessing || dataLoading || !!accessRightStatesFetch.pending}
                      search
                      autoFocus
                    />
                  )}
                  {/* <Field
                    label={t('validFrom')}
                    placeholder={t('validFrom')}
                    name="validFrom"
                    component={FieldComponent}
                    valueComponent={DatepickerFieldValueComponent}
                    disabled={submitProcessing || dataLoading}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="YYYY-MM-dd HH:mm"
                    locale={i18n.language}
                    // format={convertToLocal}
                    showMonthDropdown
                    showYearDropdown
                  />
                  <Field
                    label={t('validUntil')}
                    placeholder={t('validUntil')}
                    name="validUntil"
                    component={FieldComponent}
                    valueComponent={DatepickerFieldValueComponent}
                    disabled={submitProcessing || dataLoading}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="YYYY-MM-dd HH:mm"
                    locale={i18n.language}
                    // format={convertToLocal}
                    showMonthDropdown
                    showYearDropdown
                  /> */}
                </Fragment>
              ),
            }[step]
          }
        </FetchHandlerModule>
      </FormModal>
    );
  }
}

AccessRightFormModal.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dataLoading: PropTypes.bool,
  editMode: PropTypes.bool,
  submitProcessing: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  data: PropTypes.object,
  getAccessRightStatesForSelectOptions: PropTypes.func.isRequired,
  dispatchAccessRightStatesGet: PropTypes.func.isRequired,
  accessRightStatesFetch: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  vehicleId: PropTypes.string,
  returnRoute: PropTypes.string.isRequired,
  noStateField: PropTypes.bool,
  addVehicleToPrivateListFetch: PropTypes.object.isRequired,
  dispatchAddVehicleToPrivateListPost: PropTypes.func.isRequired,
  dispatchVehicleByLicensePlateGet: PropTypes.func.isRequired,
  vehicleByLicensePlateFetch: PropTypes.object.isRequired,
  dispatchCreateVehiclePost: PropTypes.func.isRequired,
  createVehicleFetch: PropTypes.object.isRequired,
};

AccessRightFormModal.defaultProps = {
  dataLoading: false,
  editMode: false,
  data: { stateId: 1 },
  vehicleId: undefined,
  noStateField: false,
};

export default compose(
  withTranslation(),
  vehicleByLicensePlateService,
  addVehicleToPrivateListService,
  accessRightStatesService,
  createVehicleService
)(AccessRightFormModal);
